import { render } from "./BookingForm.vue?vue&type=template&id=6df30f6b&scoped=true"
import script from "./BookingForm.vue?vue&type=script&lang=js"
export * from "./BookingForm.vue?vue&type=script&lang=js"

import "./BookingForm.vue?vue&type=style&index=0&id=6df30f6b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6df30f6b"

export default script